import { FACE_ENROLLMENT_PUBLIC_ROUTE } from '@/config/routes/people';

export default [
  {
    name: FACE_ENROLLMENT_PUBLIC_ROUTE.ROUTE_NAME,
    path: FACE_ENROLLMENT_PUBLIC_ROUTE.ROUTE_PATH,
    components: {
      default: () =>
        import(/* webpackChunkName: "public-face-enrollment" */ '@/views/face-enrollment/PublicFaceEnrollmentPage.vue')
    }
  }
];
